import { render, staticRenderFns } from "./p28.vue?vue&type=template&id=45c2487e&scoped=true&"
import script from "./p28.vue?vue&type=script&lang=js&"
export * from "./p28.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c2487e",
  null
  
)

export default component.exports